/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import * as app from "../../services/AppService";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import Button from "../../components/Button";
import Row from "../../components/Row";
import * as http from "../../services/http";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../store/auth";
import ColorMode from "../ColorMode";
import Language from "../Language";

export default function ShippingClientLayout(props: { children: any }) {

    const agentRouts = useSelector((store: any) => store.data.routs);

    const options = useSelector((store: any) => store.data.options);

    const [mobileMode, setMobileMode] = useState(window.innerWidth <= 768);

    const [model, setModel] = useState({
        menu: [],
        parentName: "",
        Level: 0,
        navigation: [],
        ActiveIndex: -1,
    });

    const [control, setControl] = useState({
        showAgentInfo: true,
        isMenuOpen: !mobileMode,
        menuData: [],
        AllBalances: false,
    });

    function checkWidth() {
        const w = window.innerWidth;
        if (w <= 768) {
            setMobileMode(true);
            setControl((old) => ({ ...old, isMenuOpen: false }));
        } else {
            setMobileMode(false);
        }
    }

    useEffect(() => {
        var menuData = agentRouts.filter((item: any, index: number, array: any) => item.parentId === 1);
        setModel((old) => ({ ...old, menu: menuData }));
    }, []);

    const navigate = useNavigate();


    function openUrl(url: string) {
        if (url === "/Remitt/RemRec" && +options.RemOption === 1 && +options.IsCentralBank === 0) {
            url = "Remitt/RemittRec";
        }
        hideMenu();
        navigate(url);
    }

    async function UpdateMenu(item: any, goBack = false) {
        openUrl(item.path + (item.ulrParam ? "/" + item.ulrParam : ""));
    }

    function hideMenu() {
        if (mobileMode) {
            setControl((old) => ({ ...old, isMenuOpen: false }));
        }
    }

    const optionInfo = useSelector((store: any) => store.data.options);
    const dispatch = useDispatch();
    function Logout() {
        http.get("/CustomerLogin/LogOut", {}, (res) => {
            dispatch(logout());
            window.open("/", "_self");
        });
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener("resize", checkWidth);

        return () => window.removeEventListener("resize", checkWidth);
    }, []);

    return (
        <div style={{ height: "calc(100vh - 88px)" }} className="bg-body fade-in agent-layout">

            <>
                <Navbar bg="body-tertiary" expand="lg"
                    className="sticky-top shadow-sm text-light-emphasis agent-top-header">
                    <Container fluid>
                        <button className="btn bg-body me-3 shadow-sm border-secondary border-1 text-secondary rounded-1"
                            onClick={() => setControl((old) => ({ ...old, isMenuOpen: !old.isMenuOpen }))} type="button">
                            <span className="iconssc-menu "></span>
                        </button>

                        <Navbar.Brand className="bg-transparent shadow-none">
                            <img src={optionInfo.companyLogo.length === 0 ? "images/logo.png" : "data:image/jpeg;base64," + optionInfo.companyLogo}
                                height="35" alt="React Bootstrap logo" />
                        </Navbar.Brand>

                        <Navbar.Toggle aria-controls="navbarScroll" />

                        <Navbar.Collapse id="navbarScroll" >

                            <div className="d-inline-flex align-items-center">
                                <Nav.Link className="mx-2 d-none d-md-block text-dark-emphasis">
                                    {app.translate("GeneralNews")}
                                </Nav.Link>
                            </div>

                            <div style={{ direction: "ltr" }}
                                className="flex-fill w-50 d-none d-md-block text-dark-emphasis">
                            </div>

                            <div className="d-flex justify-content-end">


                                <Language />
                                <ColorMode />

                                <Button class="outline-primary  text-primary-emphasis" icon="off fw-bold" tooltip="Signout" clicked={Logout} />
                            </div>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>

            </>
            <div className={`bd-sidebar bg-body sidebar ${control.isMenuOpen ? "show" : "hide"}`}>

                <div className=" d-flex flex-column w-100 h-100">
                    <div className="flex-grow-1 m-2 overflow-y-auto overflow-x-hidden z-10">
                        <div className="">
                            <>
                                <Row>
                                    <Button icon="home" iconSize="5" label="Home"
                                        class={`w-100 bg-primary text-white py-1 d-flex justify-content-between align-items-center`}
                                        clicked={() => {
                                            setModel({
                                                menu: control.menuData,
                                                parentName: "",
                                                Level: 0,
                                                navigation: [],
                                                ActiveIndex: -1
                                            });
                                            openUrl("/ShippClientDashboard");
                                        }} />
                                </Row>

                                {model.menu.map((item: any, index: number) => (
                                    <div className={`mt-1`} key={index}>
                                        <Button icon="left-arrow t-color" label={item.name}
                                            class={`w-100 py-1 d-flex justify-content-between align-items-center  ${+model.ActiveIndex === +index
                                                ? "text-white btn-primary" : "text-primary-emphasis border-1 border-primary"}`}
                                            clicked={() => {
                                                UpdateMenu(item);
                                                hideMenu();
                                            }}
                                        />
                                    </div>
                                ))}
                            </>
                        </div>
                    </div>

                    <div className="m-2">
                    </div>
                </div>
            </div>
            <main
                className={`d-flex flex-xl-nowrap w-100 overflow-auto bg-body ${control.isMenuOpen ? "menu-open" : ""}`}>
                <div className="card bg-body border-0 container-fluid mt-5">
                    <div className=" pt-2">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0">
                                {model.navigation.map((nav, index) => (
                                    <li className="h5 text-primary-emphasis fw-bold breadcrumb-item" key={index}>
                                        {app.translate(nav)}
                                    </li>
                                ))}
                            </ol>
                        </nav>
                    </div>
                    <div>
                        {props.children}
                    </div>
                </div>
            </main>
        </div>
    );
}